autoslash.createNamespace("autoslash.autocomplete");
autoslash.register(autoslash.autocomplete);

autoslash.autocomplete.initialize = function (element) {
    "use strict";
    element.find("[data-autoslash-autocomplete]").each(function() {
        const input = $(this);
        
        // Adopt server-rendered token if present, else mint
        if (!input.data("autoslash-autocomplete-token")) {
            input.data("autoslash-autocomplete-token", crypto.randomUUID());
        }
        
        const suggestService = input.data("autoslash-autocomplete-suggest");
        const validateService = input.data("autoslash-autocomplete-validate");
        const minLength = input.data("autoslash-autocomplete-minlength");
        const params = input.data("autoslash-autocomplete-params");
        const hiddenFieldElementId = input.data("autoslash-autocomplete");
        const hiddenField = $("#" + hiddenFieldElementId);

        input.autocomplete({
            minLength: minLength,
            autoFocus: true,
            source: function(request, response) {
                let sessionToken = input.data("autoslash-autocomplete-token");
                let data = {search: request.term, sessionToken: sessionToken};
                if (params) {
                    $.extend(data, params);
                }

                //Suggestion Service
                $.ajax({
                    global: false,
                    url: suggestService,
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json",
                    async: true,
                    data: JSON.stringify(data),
                    success: function(data) {
                        response($.map(data, function(item) {
                            return {
                                id: item.Value,
                                label: item.Suggestion,
                                value: item.Text
                            };
                        }));
                    }
                });
            },
            change: function(event, ui) {
                if (!ui.item) {
                    hiddenField.val("");

                    if (!validateService) {
                        input.val("");
                        return;
                    }

                    let sessionToken = input.data("autoslash-autocomplete-token");
                    let data = {search: input.val(), sessionToken: sessionToken};
                    if (params) {
                        $.extend(data, params);
                    }

                    //Validation Service
                        $.ajax({
                            global: false,
                            url: validateService,
                            type: "POST",
                            dataType: "json",
                            contentType: "application/json",
                            async: false,
                            data: JSON.stringify(data),
                            success: function (data) {
                                if (data.IsValid) {
                                    input.val(data.SearchResult.Text);
                                    hiddenField.val(data.SearchResult.Value);
                                } else {
                                    input.val("");
                                    hiddenField.val("");
                                }
                            }
                        });
                } else {
                    hiddenField.val(ui.item.id);
                }
            }
        });

        input.keypress(function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    });
};